import { forwardRef } from 'react';
import type { ButtonProps as AntButtonProps } from 'antd';

import { StyledButton, type ButtonColor } from './Button.styled';

export type ButtonProps = Omit<AntButtonProps, 'color'> & {
  color?: ButtonColor;
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { color, type = 'default', ...props },
  ref
) {
  const { icon, ...restProps } = props;

  return (
    <StyledButton
      ref={ref}
      $color={color}
      type={type}
      {...restProps}
      icon={icon ? <span className="button-icon">{icon}</span> : null}
    />
  );
});

export default Button;
